import { memoize, sum } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { getComponentDesignQuantities, getFlattenedChildrenWithCalculatedQuantity } from '@paragon/layout-models';

export const getTotalComponentCount = createSelector(
  getFlattenedChildrenWithCalculatedQuantity,
  (getFlattenedChildrenWithCalculatedQuantityForModel) =>
    memoize((projectGuid: string) =>
      sum(Object.values(getComponentDesignQuantities(getFlattenedChildrenWithCalculatedQuantityForModel(projectGuid)))),
    ),
);
